import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/apiservices'

class Designations extends Component {
    constructor() {
        super()
        this.state = {
            designationsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getDesignationList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getDesignationList = () => {
        apiService.getDesignationsDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        designationsList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.designationsList).map((value,index) => {
            
            return {
                label : this.state.designationsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Designation"
                options={list}
                disabled={this.props.disabled}
                onChange={(e) => { (e) ? this.props.designationChange(e) : this.props.designationChange([])}}
                />
            </div>
        )
    }
}
export default Designations


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/Designations.js